import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";

import {
  hooks as walletConnectV2Hooks,
  walletConnectV2,
} from "./utils/Web3Connection/connectors/walletConnectV2";
import {
  hooks as metaMaskHooks,
  metaMask,
} from "./utils/Web3Connection/connectors/metaMask";
import { Web3ReactProvider } from "@web3-react/core";

const connectors = [
  [walletConnectV2, walletConnectV2Hooks],
  [metaMask, metaMaskHooks],
];


// Lazy load page components
const NewLandingPage = lazy(() => import("./Pages/NewLandingPage/NewLandingPage"));
const Home = lazy(() => import("./Pages/Home/Home"));
const TilesAndProcedures = lazy(() => import("./Pages/TilesAndProcedures/TilesAndProcedures"));
const About = lazy(() => import("./Pages/About/About"));
const PropertiesFAQ = lazy(() => import("./Pages/PropertiesFAQ/PropertiesFAQ"));
const CitizenshipFAQ = lazy(() => import("./Pages/CitizenshipFAQ/CitizenshipFAQ"));
const PrivacyPolicy = lazy(() => import("./Pages/PrivacyPolicy/PrivacyPolicy"));
const Yourproperty = lazy(() => import("./Pages/Yourproperty/Yourproperty"));
const Plotdetail = lazy(() => import("./Pages/Yourproperty/Plotdetail"));
const Termofuse = lazy(() => import("./Pages/Termsofuse/Termofuse"));
const TokenClaim = lazy(() => import("./Pages/TokenClaim/TokenClaim"));
const Certificate = lazy(() => import("./Pages/Certificate/Certificate"));

function App() {  
  return (  
      <Web3ReactProvider connectors={connectors}>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          // theme="light"
        />
        <BrowserRouter>
		  <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/" element={<NewLandingPage />} />
            <Route path="/Home" element={<Home />} />
            <Route path="/TilesAndProcedures" element={<TilesAndProcedures />} />
            <Route path="/About" element={<About />} />
            <Route path="/PropertiesFAQ" element={<PropertiesFAQ />} />
            <Route path="/CitizenshipFAQ" element={<CitizenshipFAQ />} />
            <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
            <Route path="/termofuse" element={<Termofuse />} />
            <Route path="/yourproperty" element={<Yourproperty />} />
            <Route path="/plotdetail" element={<Plotdetail />} />
            <Route path="/LandingPg" element={<NewLandingPage />} />
            <Route path="/Certificate" element={<Certificate />} />
            <Route path="/TokenClaim" element={<TokenClaim />} />
          </Routes>
		 </Suspense>  
        </BrowserRouter>
      </Web3ReactProvider>   
  );
}

export default App;
